import PricingCardWrapper from './PricingCardWrapper'

export default PricingCardWrapper
